module.exports = __webpack_public_path__ + "8c0d080474e5c2f0cffe6f684b6c1393.jpeg";